// App.js
import React from 'react';
import Game from './components/Game';
import './App.css';

const App = () => {
  return (
    <div className="app-container">
      <Game />
    </div>
  );
};

export default App;
